import { useMemo } from "react";
import {
  Badge,
  Container,
  Dropdown,
  Form,
  Nav,
  Navbar,
  NavDropdown,
  Placeholder,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import NFeCode from "./NFe.Code";
import { getLabel } from "src/hook/Functions";
import DatePicker from "react-datepicker";
import { NavDatePicker } from "src/componentes/NavDatePicker/NavDatePicker.Component";
import moment from "moment";
import "./Styles.css";
import NFeModalPropriedadesView from "./Modal.Propriedades/NFe.Modal.Propriedades.View";
import NFeModalNovoView from "./Modal.Novo/NFe.Modal.Novo.View";
import { getVisualStatusNFe, statusEnvioNFeOptions } from "./NFe.Dto";

const NFeView = () => {
  const code = NFeCode();

  const contadores = useMemo(() => {
    let naoEnviados = 0;
    let enviados = 0;
    let cancelados = 0;

    code.data.forEach((item) => {
      const visual = getVisualStatusNFe(item);
      if (
        visual.categoria === "nao_enviado" ||
        visual.categoria === "em_processamento"
      ) {
        naoEnviados++;
      } else if (visual.categoria === "enviado_autorizado") {
        enviados++;
      } else if (
        visual.categoria === "cancelado" ||
        visual.categoria === "rejeitado"
      ) {
        cancelados++;
      }
    });

    return { naoEnviados, enviados, cancelados };
  }, [code.data]);

  return (
    <>
      <Container>
        <HeadPage headText="NFe" onToggle={code.menu.handleMenuToggleClick}>
          {code.menu.menuItens !== undefined &&
            code.menu.menuItens.map((item) => (
              <Dropdown.Item
                key={item.nome}
                onClick={code.menu.handleMenuClick(item)}
              >
                {item.nome}
              </Dropdown.Item>
            ))}
        </HeadPage>
        {!code.loading ? (
          <>
            <Navbar className="bg-body-tertiary justify-content-between">
              <Container>
                <Navbar.Collapse className="justify-content-end">
                  <Nav className="ms-auto">
                    <Form.Control
                      placeholder="Série"
                      className="bg-body-tertiary"
                      onChange={code.handleChangeSerie}
                      value={
                        code.useFilter.filters.serie &&
                        code.useFilter.filters.serie > 0
                          ? code.useFilter.filters.serie.toString()
                          : ""
                      }
                    />
                    <NavDropdown
                      onSelect={code.handleSelectStatus}
                      id="dropdown-codigoStatusEnvio"
                      title={getLabel(
                        statusEnvioNFeOptions,
                        code.useFilter.filters.codigoStatusEnvio,
                        "Status Envio"
                      )}
                    >
                      {statusEnvioNFeOptions.map((option) => (
                        <NavDropdown.Item
                          key={option.value}
                          eventKey={option.value}
                          active={
                            code.useFilter.filters.codigoStatusEnvio ===
                            option.value
                          }
                        >
                          {option.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>

                    <DatePicker
                      locale="pt-BR"
                      selected={code.useFilter.filters.dataEmissaoInicial}
                      onChange={code.handleSetDates}
                      startDate={code.useFilter.filters.dataEmissaoInicial}
                      endDate={code.useFilter.filters.dataEmissaoFinal}
                      selectsRange
                      dateFormat="dd/MM/yyyy"
                      withPortal
                      isClearable={true}
                      className="nav-datepicker"
                      title={code.getDatePickerTitle()}
                      customInput={<NavDatePicker />}
                    />
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>

            {/* Chips de filtro rápido por status visual */}
            <div className="d-flex flex-wrap align-items-center gap-2 mt-2 px-1">
              <span className="small text-muted fw-semibold me-1">Status:</span>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("99")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  !code.useFilter.filters.codigoStatusEnvio ||
                  code.useFilter.filters.codigoStatusEnvio === "99"
                    ? "btn-dark text-white fw-bold"
                    : "btn-outline-secondary text-body"
                }`}
              >
                <span>Todos</span>
                <span className="badge bg-secondary rounded-pill ms-1">
                  {code.data.length}
                </span>
              </button>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("0")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  code.useFilter.filters.codigoStatusEnvio === "0"
                    ? "btn-warning text-dark fw-bold border border-warning"
                    : "btn-outline-warning text-body"
                }`}
                title="NF-es que ainda não foram enviadas ou autorizadas pela SEFAZ"
              >
                <span>⏳ Não Enviadas</span>
                <span className="badge bg-warning text-dark rounded-pill ms-1">
                  {contadores.naoEnviados}
                </span>
              </button>

              <button
                type="button"
                onClick={() => code.handleSelectStatus("2")}
                className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                  code.useFilter.filters.codigoStatusEnvio === "2"
                    ? "btn-success text-white fw-bold border border-success"
                    : "btn-outline-success text-body"
                }`}
                title="NF-es autorizadas pela SEFAZ"
              >
                <span>✓ Enviadas e Autorizadas</span>
                <span className="badge bg-success text-white rounded-pill ms-1">
                  {contadores.enviados}
                </span>
              </button>

              {contadores.cancelados > 0 && (
                <button
                  type="button"
                  onClick={() => code.handleSelectStatus("3")}
                  className={`btn btn-sm py-1 px-3 rounded-pill d-inline-flex align-items-center gap-1 shadow-sm ${
                    code.useFilter.filters.codigoStatusEnvio === "3" ||
                    code.useFilter.filters.codigoStatusEnvio === "4" ||
                    code.useFilter.filters.codigoStatusEnvio === "3,4"
                      ? "btn-danger text-white fw-bold border border-danger"
                      : "btn-outline-danger text-body"
                  }`}
                  title="NF-es canceladas ou denegadas"
                >
                  <span>✕ Canceladas / Denegadas</span>
                  <span className="badge bg-danger text-white rounded-pill ms-1">
                    {contadores.cancelados}
                  </span>
                </button>
              )}

              {code.useFilter.filters.codigoStatusEnvio &&
                code.useFilter.filters.codigoStatusEnvio !== "99" && (
                  <button
                    type="button"
                    onClick={() => code.handleSelectStatus("99")}
                    className="btn btn-sm btn-link py-0 px-2 text-decoration-none text-muted"
                  >
                    ✕ Limpar filtro
                  </button>
                )}
            </div>

            {code.data.length === 0 ? (
              <div className="text-center py-5 text-muted">
                Nenhuma NF-e encontrada para os filtros selecionados.
              </div>
            ) : (
              <Table responsive hover className="mt-2 no-border">
                <tbody>
                  {code.data.map((item) => {
                    const visual = getVisualStatusNFe(item);
                    return (
                      <tr
                        key={item.id}
                        style={{ cursor: "pointer" }}
                        onClick={code.handleClickPropriedades(item)}
                      >
                        <td colSpan={5} className="p-0">
                          <div className="border rounded p-2 mb-2">
                            <div className="d-flex align-items-center flex-wrap">
                              <div className="flex-grow-0 me-3">
                                <Badge
                                  bg={visual.badgeBg}
                                  text={visual.badgeText}
                                  className="px-2 py-1 fs-7 fw-semibold d-inline-flex align-items-center gap-1 shadow-sm"
                                >
                                  <span>{visual.iconSymbol}</span>
                                  <span>{visual.label}</span>
                                </Badge>
                              </div>

                              <div className="flex-grow-0 me-3 fw-bold">
                                NF: {item.numeroNF}
                              </div>

                              <div className="flex-grow-0 me-3">
                                Série: {item.serie}
                              </div>

                              <div className="flex-grow-1 text-truncate me-3">
                                Sefaz: {item.autorizacao.codigoStatusEnvio}-
                                {item.autorizacao.descricaoStatusEnvio}
                              </div>

                              <div className="flex-grow-1 text-truncate d-none d-md-block me-3">
                                {item.autorizacao.codigoStatusResposta}-
                                {item.autorizacao.descricaoMotivoResposta}
                              </div>

                              <div className="ms-auto text-end">
                                Emissão:{" "}
                                {moment(item.emissaoDataHora).format(
                                  "DD/MM/YYYY HH:mm:ss"
                                )}
                              </div>

                              {/* “quebra de linha” */}
                              <div className="w-100 my-1"></div>

                              <div className="flex-grow-1">
                                <small className="text-muted">Destinatário</small>
                                <div className="text-muted">
                                  {item.destinatario?.nome}
                                </div>
                              </div>

                              <div className="text-end">
                                <small className="text-muted">Total</small>
                                <div className="text-muted">
                                  R$ {item.total?.valorNotaFiscal?.toFixed(2)}
                                </div>
                              </div>

                              <div className="w-100"></div>

                              <div className="flex-grow-1">
                                <small className="text-muted">Documento</small>
                                <div className="text-muted">
                                  {item.destinatario?.documento}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
          </>
        ) : (
          <Placeholder animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Container>

      <NFeModalPropriedadesView
        show={code.modalShowPropriedades}
        nfe={code.nfe}
        onReturn={code.onReturnModalPropriedades}
        onDelete={code.onDeleteModalPropriedades}
        onPrint={code.onPrintModalPropriedades}
        onDownloadDanfe={code.onModalPropriedadesDownloadDanfe}
        onShareDanfe={code.onModalPropriedadesShareDanfe}
        onDownloadXml={code.onDownloadXml}
        onFetchStatus={code.onFetchStatusModalPropriedades}
        onSend={code.onSendModalPropriedades}
        onEdit={code.onEditModalPropriedades}
        onDuplicate={code.onDuplicateModalPropriedades}
        onEvent={code.onEventModalPropriedades}
        onVisualizar={code.onVisualizarModalPropriedades}
      />

      <NFeModalNovoView
        show={code.modalNovoShow}
        onContinuar={code.onContinuarModalNovo}
        onCriarNovo={code.onCriarNovoModalNovo}
        onCancel={code.onCancelModalNovo}
      />
    </>
  );
};
export default NFeView;
